import React from 'react';
import TrendSparkline from '../ui/TrendSparkline';

const TrendSection = ({
  selectedPeriod,
  timeline,
  globalDeltaMeta,
  bestPeriodEntry,
  lowestPeriodEntry,
  strongestMomentum,
  dataPdfSource,
}) => {
  const selectedIndex = timeline.findIndex((point) => point.label === selectedPeriod);
  const strongestTone = strongestMomentum?.delta >= 0 ? 'text-emerald-500' : 'text-rose-500';

  return (
    <div className="card-premium overflow-hidden" data-pdf-break="true" data-pdf-source={dataPdfSource}>
      {/* Header */}
      <div className="px-6 pt-5 pb-4 flex items-center justify-between gap-4">
        <div>
          <p className="text-[0.6rem] uppercase text-slate-400">Tendencia del barómetro</p>
          <p className="text-lg font-semibold text-slate-900 mt-0.5">Evolución histórica del índice</p>
        </div>
        {globalDeltaMeta && (
          <div className="text-right flex-shrink-0">
            <p className="text-[0.6rem] uppercase text-slate-400">Variación actual</p>
            <p className={`text-base font-bold ${globalDeltaMeta.trendClass}`}>{globalDeltaMeta.formatted}</p>
          </div>
        )}
      </div>

      {/* Chart panel — edge-to-edge dark */}
      <div className="bg-trend-gradient px-6 pt-4 pb-5 border-t border-b border-white/[0.06]">
        <TrendSparkline points={timeline} color="#4A8FE8" highlightIndex={selectedIndex} height={130} />
        <div
          className="mt-3 grid gap-1.5"
          style={{ gridTemplateColumns: `repeat(${Math.min(timeline.length, 12)}, minmax(0, 1fr))` }}
        >
          {timeline.map((point) => {
            const isSelected = point.label === selectedPeriod;
            return (
              <div
                key={point.label}
                className={`rounded-lg px-1.5 py-2 text-center transition-colors ${isSelected ? 'bg-[#4A8FE8]/20 ring-1 ring-[#4A8FE8]/40' : 'bg-white/[0.04] hover:bg-white/[0.07]'}`}
              >
                <p className="text-[0.5rem] uppercase text-white/40 truncate leading-tight">{point.label}</p>
                <p className={`text-sm font-bold leading-tight mt-0.5 ${isSelected ? 'text-white' : 'text-white/55'}`}>
                  {typeof point.value === 'number' ? point.value.toFixed(1) : '—'}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-3 divide-x divide-slate-100/70">
        <div className="px-5 py-4">
          <p className="text-[0.58rem] uppercase text-slate-400">Mejor período</p>
          <p className="text-base font-bold text-slate-900 mt-1 leading-tight">{bestPeriodEntry?.label || '—'}</p>
          <p className="text-xs text-emerald-600 font-semibold mt-0.5">{bestPeriodEntry ? `${bestPeriodEntry.value.toFixed(1)} pts` : ''}</p>
        </div>
        <div className="px-5 py-4">
          <p className="text-[0.58rem] uppercase text-slate-400">Período más débil</p>
          <p className="text-base font-bold text-slate-900 mt-1 leading-tight">{lowestPeriodEntry?.label || '—'}</p>
          <p className="text-xs text-rose-500 font-semibold mt-0.5">{lowestPeriodEntry ? `${lowestPeriodEntry.value.toFixed(1)} pts` : ''}</p>
        </div>
        <div className="px-5 py-4">
          <p className="text-[0.58rem] uppercase text-slate-400">Mayor movimiento</p>
          <p className="text-base font-bold text-slate-900 mt-1 leading-tight">{strongestMomentum?.label || '—'}</p>
          <p className={`text-xs font-semibold mt-0.5 ${strongestTone}`}>
            {strongestMomentum ? `${strongestMomentum.delta >= 0 ? '+' : ''}${strongestMomentum.delta.toFixed(1)} pts` : 'Sin variación comparable'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrendSection;
